export const SELECTED_CHAT_ID_QUERY_PARAM = "selectedChatId";
